export const QUESTIONS_M = [
// M01
// 1. 全身麻酔の流れ
{
  q: '①全身麻酔の3要素は【鎮静】，【鎮痛】，【筋弛緩】である．',
  s: 'M01', ch: '全身麻酔の流れ',
},
{
  q: '②麻酔導入の種類',
  s: 'M01', ch: '全身麻酔の流れ',
  type: 'indent',
  rows: [
    { level: 0, text: '・【急速】導入：最も一般的' },
    { level: 0, text: '・【緩徐】導入：静脈路確保が困難な小児などで行う' },
    { level: 0, text: '・【迅速】導入：誤嚥のリスクの高い患者で行う' },
  ]
},
{
  q: '③麻酔の急速導入の手順',
  s: 'M01', ch: '全身麻酔の流れ',
  type: 'indent',
  rows: [
    { level: 0, text: '・マスクで【酸素】投与する．' },
    { level: 0, text: '・【静脈】麻酔(【プロポフォール】，チオペンタール，ケタミン，ミダゾラム)で鎮静をかける．' },
    { level: 0, text: '・【睫毛】反射消失で鎮静を確認し，【筋弛緩】薬(【ロクロニウム】，ベクロニウム)を投与する．' },
    { level: 0, text: '・十分なマスク換気後に【気管挿管】する．' },
    { level: 0, text: '・【吸入】麻酔薬(【セボフルラン】，デスフルラン，笑気)で鎮静維持する．' },
    { level: 0, text: '・【麻薬性鎮痛】薬(【レミフェンタニル】，フェンタニル，モルヒネ)で鎮痛する．' },
    { level: 0, text: '・筋弛緩薬の拮抗薬(【スガマデクス】)を投与する．' },
    { level: 0, text: '・意識があり握手，舌を前に出すことができることを確認して【抜管】する．' },
    { level: 0, text: '※ 硬膜外麻酔が必要であれば，【鎮静】の前に行う．' },
  ]
},
{
  q: '④緩徐導入は【小児】などで行われる麻酔導入である．まず【吸入麻酔】薬で鎮静させ，その後静脈路確保し投薬，気管挿管を行う．',
  s: 'M01', ch: '全身麻酔の流れ',
},
{
  q: '⑤迅速導入は【フルストマック】患者の誤嚥防止のために行われる麻酔導入である．胃へのガス流入を防ぐため，【マスク換気】を行わず気管挿管する．このとき【輪状軟骨】を圧迫し，嘔吐を防ぎながら挿管する(セリック法)．',
  s: 'M01', ch: '全身麻酔の流れ',
},

// 2. 静脈麻酔
{
  q: '①全身麻酔の導入薬として最も使用される静脈麻酔薬は【プロポフォール】である．導入だけでなく麻酔の維持にも用いられる．【GABA受容体作動】薬の1つで中枢神経全体を抑制し，【呼吸】抑制もある．注入時に【血管痛】を生じることが特徴．禁忌は【卵】や【大豆】アレルギー患者，【妊婦】(胎盤移行性あり)で，【小児】への大量投与も禁忌となる．',
  s: 'M01', ch: '静脈麻酔',
},
{
  q: '②バルビツレート系の麻酔薬に【チオペンタール】とチアミラールがある．副交感神経刺激とヒスタミン遊離により喉頭痙攣・気管支痙攣をきたすため，【喘息】患者には禁忌．【GABA受容体作動】薬の1つである．',
  s: 'M01', ch: '静脈麻酔',
},
{
  q: '③解離性麻酔薬である【ケタミン】は，新皮質と視床のみを抑制し，辺縁系と網様体賦活系を亢進させる(中枢神経全体を抑制しない)．【悪夢】を生じることが特徴．多くの麻酔薬が血圧を【低下】させるのに対し，ケタミンでは【交感】神経優位となり，【高】血圧，【頻】脈，気管支【拡張】をきたす．よって【ショック】や【喘息】患者に用いることができるが，【頭蓋内圧亢進】や【てんかん】のある患者には使いづらい．【鎮痛】作用(体性痛)を有する，【呼吸抑制】が少ないといった特徴もある．',
  s: 'M01', ch: '静脈麻酔',
},
{
  q: '④ベンゾジアゼピン系で経静脈投与可能なものとして，【ジアゼパム】，フルニトラゼパム，ミダゾラムがある．抗【痙攣】作用を有する．【鎮痛】作用はない．',
  s: 'M01', ch: '静脈麻酔',
},
{
  q: '⑤静脈麻酔薬の比較',
  s: 'M01', ch: '静脈麻酔',
  type: 'grouped',
  categories: [
      {
      label: '分類',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: 'GABA受容体作動薬：中枢神経全体を抑制,【呼吸抑制】あり' },
        { term: 'チオペンタール', desc: 'GABA受容体作動薬' },
        { term: 'ケタミン', desc: '【解離性麻酔】薬：交感神経↑' },
      ]}]
    },
    {
      label: '鎮静',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '+' },
        { term: 'チオペンタール', desc: '+' },
        { term: 'ケタミン', desc: '+' },
      ]}]
    },
    {
      label: '鎮痛',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '【−】' },
        { term: 'チオペンタール', desc: '【−】' },
        { term: 'ケタミン', desc: '【+】(体性痛)' },
      ]}]
    },
    {
      label: '血圧',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '【↓】' },
        { term: 'チオペンタール', desc: '【↓】' },
        { term: 'ケタミン', desc: '【↑】' },
      ]}]
    },
    {
      label: '使用可',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '喘息' },
        { term: 'チオペンタール', desc: '【頭蓋内圧亢進】' },
        { term: 'ケタミン', desc: '【ショック】，【喘息】' },
      ]}]
    },
    {
      label: '使用不可',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '【卵・大豆】アレルギー，【妊婦】，【小児】への大量投与' },
        { term: 'チオペンタール', desc: '【喘息】，ポルフィリン症' },
        { term: 'ケタミン', desc: '【頭蓋内圧亢進】，【てんかん】' },
      ]}]
    },
    {
      label: '特徴',
      groups: [{ label: '', rows: [
        { term: 'プロポフォール', desc: '【血管痛】' },
        { term: 'チオペンタール', desc: '−' },
        { term: 'ケタミン', desc: '唾液分泌亢進，【悪夢】' },
      ]}]
    },
  ]
},

// 3. 吸入麻酔
{
  q: '①最も使用される吸入麻酔薬は【セボフルラン】である．沸点が低く特殊な気化器を要する吸入麻酔薬に【デスフルラン】がある．セボフルランやデスフルランは【鎮静】作用が強く，【鎮痛】作用はない．筋弛緩，呼吸・循環抑制がある．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '②脳外科の麻酔に使用することがある吸入麻酔薬に【イソフルラン】がある．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '③ガス麻酔薬の【笑気】(【亜酸化窒素】)は鎮静作用・鎮痛作用をもつが効果は弱い．閉鎖腔を拡大させるため，【気胸】や【イレウス】の患者での使用は原則禁忌．笑気投与終了後は純酸素の投与が必要(【拡散性低酸素症】をきたすため)．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '④高濃度ガスと低濃度ガスを併用した際に，高濃度ガスが肺胞から血液に素早く移動し，肺胞内で低濃度ガスの濃度が高まることを【二次ガス効果】という．高濃度ガスに笑気，低濃度ガスにセボフルランを用いるとセボフルランの濃度が相対的に高まり吸入麻酔での導入が速くなる．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '⑤皮膚切開で50%の患者が体動を起こさなくなる吸入麻酔薬の肺胞内濃度を【最小肺胞内濃度】(【MAC】)という．この値が小さい方が麻酔作用は【強】い．笑気のMACは【大き】い．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '⑥血液と肺胞の間が平衡状態のときに，血液1mLに溶けているガスの量を【血液/ガス分配係数】という．この値が小さいほど導入・覚醒の速度が【速】い．この値が大きい(血中に溶け込み【やす】い)ほど導入・覚醒の速度が【遅】い．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '⑦麻酔の導入速度',
  s: 'M01', ch: '吸入麻酔',
  type: 'indent',
  rows: [
    { level: 0, text: '・心拍出量が多いと肺血流量が増加し，肺胞と血液の間が平衡状態になりにくい．したがって導入速度は【遅】くなる．' },
    { level: 0, text: '・機能的残気量が多いと麻酔薬が薄まるため，導入速度は【遅】くなる．【肥満】者や【妊婦】は機能的残気量が減少するため導入速度は【速】くなる．' },
    { level: 0, text: '※ 肥満者は脂肪組織に吸入麻酔薬が残りやすく覚醒速度が【遅】くなる．' },
  ]
},
{
  q: '⑧麻酔回路で用いるCO2吸着剤(【ソーダライム】)は呼気のCO2を除去することで，吸気ガスとして再利用する働きがある．',
  s: 'M01', ch: '吸入麻酔',
},
{
  q: '⑨麻酔回路における配管の色',
  s: 'M01', ch: '吸入麻酔',
  type: 'indent',
  rows: [
    { level: 0, text: '・酸素：【緑】色' },
    { level: 0, text: '・笑気：【青】色' },
    { level: 0, text: '・空気：【黄】色' },
  ]
},

// 4. 鎮痛薬
{
  q: '①鎮痛薬は【麻薬性鎮痛】薬(オピオイド)と【麻薬拮抗性鎮痛】薬(非麻薬性鎮痛薬)に類別される．',
  s: 'M01', ch: '鎮痛薬',
},
{
  q: '②麻薬性鎮痛薬(オピオイド)の特徴',
  s: 'M01', ch: '鎮痛薬',
  type: 'indent',
  rows: [
    { level: 0, text: '・【モルヒネ】，【フェンタニル】，【レミフェンタニル】などが代表的．' },
    { level: 0, text: '・オピオイド受容体に結合し，強力な【鎮痛】効果をもつ．' },
    { level: 0, text: '・副作用に【呼吸抑制】，【耐性】，【依存性】がある．' },
    { level: 0, text: '・拮抗薬は【ナロキソン】．' },
    { level: 0, text: '・モルヒネはヒスタミンを遊離するため【喘息】患者には用いない．' },
    { level: 0, text: '・フェンタニルやレミフェンタニルの急速投与で【鉛管様硬直】をきたすことがある．治療は【筋弛緩】薬投与．' },
  ]
},
{
  q: '③レミフェンタニルの特徴',
  s: 'M01', ch: '鎮痛薬',
  type: 'indent',
  rows: [
    { level: 0, text: '・作用発現・消失が【速やか】で蓄積性がなく，また【肝】・【腎】障害があっても使用でき，使い勝手が良い．' },
    { level: 0, text: '・【静脈】内投与のみ可能(脊髄くも膜下腔や硬膜外腔への投与はモルヒネ，フェンタニルを使用する)．' },
  ]
},
{
  q: '④麻薬拮抗性鎮痛薬の特徴',
  s: 'M01', ch: '鎮痛薬',
  type: 'indent',
  rows: [
    { level: 0, text: '・【ペンタゾシン】などが代表的．' },
    { level: 0, text: '・すべてのオピオイド受容体に対する作用が増強するのではなく，一部の受容体に対して拮抗的に作用する鎮痛薬である．' },
    { level: 0, text: '・麻薬と併用すると【拮抗】薬として働くため併用しない．' },
    { level: 0, text: '・依存性は【ある】．' },
    { level: 0, text: '・天井効果があり，極めて強い痛みには効果が不十分．' },
  ]
},

// 5. 筋弛緩薬・悪性高熱症
{
  q: '①筋弛緩薬は【脱分極】性筋弛緩薬(現在あまり用いられない)と【非脱分極】性筋弛緩薬に大別される．',
  s: 'M01', ch: '筋弛緩薬・悪性高熱症',
},
{
  q: '②脱分極性筋弛緩薬',
  s: 'M01', ch: '筋弛緩薬・悪性高熱症',
  type: 'indent',
  rows: [
    { level: 0, text: '・【サクシニルコリン】(【スキサメトニウム】)が現在臨床で用いられる．' },
    { level: 0, text: '・脱分極により一過性の骨格筋の【線維束攣縮】を認める．' },
    { level: 0, text: '・重大な副作用に【悪性高熱症】がある．' },
    { level: 0, text: '・禁忌は悪性高熱症，【腎不全】，【熱傷】，【緑内障】' },
  ]
},
{
  q: '③非脱分極性筋弛緩薬',
  s: 'M01', ch: '筋弛緩薬・悪性高熱症',
  type: 'indent',
  rows: [
    { level: 0, text: '・【ロクロニウム】，【ベクロニウム】が用いられる．' },
    { level: 0, text: '・AChの作用を阻害し，脱分極できないようにして筋肉を弛緩させる．' },
    { level: 0, text: '・拮抗薬は【スガマデクス】，【ネオスチグミン】(抗ChE薬)．' },
  ]
},
{
  q: '④脱分極性筋弛緩薬と揮発性吸入麻酔薬の併用で【悪性高熱症】を起こすおそれがある．麻酔中に【高熱】，【筋硬直】，【ミオグロビン】尿を呈する．【家族歴】を有する．悪性症候群と類似した病態であり，特効薬は【ダントロレン】である．',
  s: 'M01', ch: '筋弛緩薬・悪性高熱症',
},
//M02
// 1. 脊髄くも膜下麻酔と硬膜外麻酔
{
  q: '①くも膜下腔に局所麻酔薬を注入する局所麻酔法を【脊髄くも膜下】麻酔という．髄液に直接麻酔薬を注入するため必要な麻酔薬の量は【少な】く，効果発現が【速】い．少量の麻酔薬で済むため局所麻酔薬中毒は【少な】いが，調節は【難しい】．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '②硬膜外腔に局所麻酔薬を注入する局所麻酔法を【硬膜外】麻酔という．脊髄くも膜下麻酔に比べ注入部位は【浅】い．術後に麻酔薬の持続投与で【術後鎮痛】がしやすい．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '③脊髄くも膜下麻酔と硬膜外麻酔の比較',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
  type: 'grouped',
  categories: [
    {
      label: '注入部位',
      groups: [{ label: '', rows: [
        { term: '脊髄くも膜下麻酔', desc: '【深い】，L3以下' },
        { term: '硬膜外麻酔', desc: '【浅い】' },
      ]}]
    },
    {
      label: '必要量',
      groups: [{ label: '', rows: [
        { term: '脊髄くも膜下麻酔', desc: '【少ない】' },
        { term: '硬膜外麻酔', desc: '【多い】' },
      ]}]
    },
    {
      label: '効果発現',
      groups: [{ label: '', rows: [
        { term: '脊髄くも膜下麻酔', desc: '【速い】' },
        { term: '硬膜外麻酔', desc: '【遅い】' },
      ]}]
    },
    {
      label: '局所麻酔薬中毒',
      groups: [{ label: '', rows: [
        { term: '脊髄くも膜下麻酔', desc: '【少ない】' },
        { term: '硬膜外麻酔', desc: '【多い】' },
      ]}]
    },
    {
      label: '調節',
      groups: [{ label: '', rows: [
        { term: '脊髄くも膜下麻酔', desc: '【難しい】' },
        { term: '硬膜外麻酔', desc: '【容易】' },
      ]}]
    },
  ]
},
{
  q: '④局所麻酔薬中毒では【多弁】・興奮がみられ，進行すると【けいれん】，呼吸停止に至る．けいれんに対し【ジアゼパム】を投与する．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '⑤麻酔薬で遮断される順番',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
  type: 'indent',
  rows: [
    { level: 0, text: '・【交感】神経 → 【温痛】覚 → 【触】覚 → 圧覚 → 【運動】神経' },
    { level: 0, text: '・交感神経は知覚神経より【広】く遮断されるので【血圧低下】に注意し，麻酔に際し【乳酸リンゲル】や【エフェドリン】(α＋β作用)を用意する．' },
  ]
},
{
  q: '⑥脊髄くも膜下麻酔と硬膜外麻酔の禁忌に【出血傾向】，穿刺部位の【感染】がある．脊髄くも膜下麻酔では【頭蓋内圧】亢進も禁忌となる．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '⑦脊髄くも膜下麻酔と硬膜外麻酔によく用いられる薬剤は【ブピバカイン】で，硬膜外麻酔では【オピオイド】(フェンタニル，モルヒネ)を併用することもある．【レミフェンタニル】は静脈麻酔薬であり，これらの麻酔法では使用しない．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '⑧麻酔高について',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
  type: 'indent',
  rows: [
    { level: 0, text: '・麻酔高は通常10～20分で固定する．' },
    { level: 0, text: '・帝王切開や虫垂炎で必要な麻酔高はT5，前立腺・膀胱の手術や鼠径ヘルニアで必要な麻酔高は【T10】(【臍】レベル)である．' },
    { level: 0, text: '・麻酔がC4まで到達すると【横隔神経】麻痺をきたすため，全身麻酔に切り替え挿管・人工呼吸器使用が必要となる．' },
    { level: 0, text: '・麻酔レベルの判定に重要な目印には【乳頭】(T4)，【剣状突起】(T6)などがある．' },
  ]
},
{
  q: '⑨脊髄くも膜下麻酔を行うときは患者に【側臥】位で臍を向くように背中を丸めてもらう．脊髄を損傷しないよう【L3】以下で穿刺し，【Jacoby】線(L4の棘突起上を通る，両側の腸骨稜を結んだ線)を目安に行う．術後合併症に感染，神経障害，腰椎穿刺後【頭痛】などがある．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '⑩脊髄くも膜下麻酔と硬膜外麻酔の手技で，【脊髄くも膜下腔】に穿刺針が到達すると髄液が出てくるのに対し，【硬膜外】に穿刺針が到達すると陰圧のため液体は吸い込まれることを覚えておくとよい．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},
{
  q: '⑪硬膜外麻酔は【全身】麻酔と併用する．',
  s: 'M02', ch: '脊髄くも膜下麻酔と硬膜外麻酔',
},

// 2. 浸潤麻酔
{
  q: '①局所麻酔薬を局所に注射しその部位の感覚を遮断する方法を【浸潤】麻酔といい，よく使われる麻酔薬は【リドカイン】である．',
  s: 'M02', ch: '浸潤麻酔',
},
{
  q: '②局所の血管収縮による【止血】，麻酔時間の【延長】，局所麻酔薬中毒の予防のために【アドレナリン】を添加することがある．ただし【耳介】，【指先】，【亀頭】には添加しない(先端部にアドレナリン添加すると【虚血】の危険がある)．',
  s: 'M02', ch: '浸潤麻酔',
},
{
  q: '③感染のある部位はアシドーシスとなっており，麻酔は効き【にく】い．',
  s: 'M02', ch: '浸潤麻酔',
},
//M03

// 1. 気管挿管の手技
{
  q: '①気管挿管に必要な器具',
  s: 'M03', ch: '気管挿管の手技',
  type: 'indent',
  rows: [
    { level: 0, text: '・【挿管チューブ】' },
    { level: 0, text: '・【スタイレット】：変形しやすい挿管チューブを一定の形に保持する針金' },
    { level: 0, text: '・【バイトブロック】：患者が挿管チューブを噛んで内腔を閉塞させないために上下の歯の間に挟む器具' },
    { level: 0, text: '・キシロカイン：スタイレットを抜きやすくする．麻酔作用も' },
    { level: 0, text: '・シリンジ：挿管チューブのカフに空気を入れる' },
    { level: 0, text: '・【喉頭鏡】：喉頭展開に用いる' },
  ]
},
{
  q: '③気管挿管の手順(右利きの場合)',
  s: 'M03', ch: '気管挿管の手技',
  type: 'indent',
  rows: [
    { level: 0, text: '・患者の頭の上に立ち，頭部を【後】屈させる' },
    { level: 0, text: '・右手で開口する(クロスフィンガー：母子と示指をクロスさせる)' },
    { level: 0, text: '・左手で喉頭鏡を用いて【喉頭展開】する' },
    { level: 0, text: '・【喉頭蓋】を持ち上げ気管に挿管チューブを入れる' },
    { level: 0, text: '・チューブ先端が【声門】を通過したらスタイレットを抜き，カフに空気を入れて【固定】する' },
    { level: 0, text: '・聴診器で両肺に吸気が入っていることを確認する' },
    { level: 0, text: '※ 挿管チューブを送り込みすぎると【片肺挿管】になる' },
  ]
},
{
  q: '④気管挿管の合併症',
  s: 'M03', ch: '気管挿管の手技',
  type: 'indent',
  rows: [
    { level: 0, text: '・食道挿管：ETCO2=0 → 【食道】挿管，ETCO2=40程度 → 【気管】挿管' },
    { level: 0, text: '・外傷：喉頭鏡を前歯をてこの支点として用いると【前歯】が折れる' },
    { level: 0, text: '・【誤嚥】：気管内吸引で予防・治療．嘔吐・誤嚥の予防にセリック法' },
  ]
},
{
  q: '⑤気管挿管困難の予測に【Mallampati】分類などが用いられる．',
  s: 'M03', ch: '気管挿管の手技',
},
{
  q: '⑥気管挿管の手技中には【酸素】投与ができないため，挿管直前に純酸素で十分に【マスク換気】をする．ただし【フルストマック】の症例ではマスク換気を行わずに気管挿管する(マスク換気で誤嚥を起こす危険があるため)．',
  s: 'M03', ch: '気管挿管の手技',
},

// 2. エアウェイとラリンジアルマスク
{
  q: '①エアウェイは【舌根沈下】のある患者の気道確保に用いる．経【口】あるいは経【鼻】的に挿入する．経鼻エアウェイの禁忌に【脳出血】(高血圧を惹起するため)，【頭蓋底骨折】(エアウェイによる脳損傷を防止するため)がある．',
  s: 'M03', ch: 'エアウェイとラリンジアルマスク',
},
{
  q: '②ラリンジアルマスクは【短】時間の手術で気道確保をする場合に用いる．フェイスマスク様の部分及び付属するチューブからなり，マスク部分のカフを膨らませて用いる．【喉頭鏡】を用いないで使用でき，【声帯】を傷つけないで済むことも利点である．ただし【嘔吐】の可能性がある場合は禁忌である．',
  s: 'M03', ch: 'エアウェイとラリンジアルマスク',
},

// 3. 侵襲的陽圧換気と非侵襲的陽圧換気
{
  q: '①侵襲的陽圧換気は【気管挿管】あるいは【気管切開】のことを指す．気管挿管を行うには鎮静が【必】要で，声帯を圧迫するため患者は声が出せない．気管挿管が長期にわたるときは，第2-3気管軟骨を切開する【気管切開】を行う．気管切開は鎮静が【不】要で，声帯の圧迫がなく患者は声を出すことができる．',
  s: 'M03', ch: '侵襲的陽圧換気と非侵襲的陽圧換気',
},
{
  q: '②非侵襲的陽圧換気(【NIPPV】，【NPPV】)はフェイスマスクを用いて行う陽圧換気である．適応に【COPD】の【急性増悪】，急性【心原性肺水腫】などがある．',
  s: 'M03', ch: '侵襲的陽圧換気と非侵襲的陽圧換気',
},
{
  q: '③NPPVが適応にならず気管挿管をしなければならない病態として，【意識状態】が悪い例，高度の【呼吸不全】，【上気道】閉塞，顔面【外傷】がある．',
  s: 'M03', ch: '侵襲的陽圧換気と非侵襲的陽圧換気',
},
{
  q: '④NPPVと気管挿管のどちらも適応となる場合には侵襲性の低い【NPPV】を優先する．',
  s: 'M03', ch: '侵襲的陽圧換気と非侵襲的陽圧換気',
},

// 4. 人工呼吸器の設定
{
  q: '①人工呼吸器のモード',
  s: 'M03', ch: '人工呼吸器の設定',
  type: 'indent',
  rows: [
    { level: 0, text: '・【CMV】(持続的強制換気) A/Cなど' },
    { level: 1, text: '自発呼吸がない場合に用いる．設定回数を強制換気する．設定回数以上の自発呼吸も強制換気．' },
    { level: 0, text: '・【SIMV】(同期式間欠的強制換気)' },
    { level: 1, text: '設定回数だけ強制換気し，設定回数以上の自発呼吸に圧を補助する．自発呼吸だけでは換気不十分のとき用いる．人工呼吸器の【離脱】時に有効．' },
    { level: 0, text: '・【CSV】(持続自発換気) CPAPなど' },
    { level: 1, text: '強制換気はしない．圧の補助とPEEPのみを行う．自発呼吸で酸素化が不十分の場合に用いる．' },
  ]
},
{
  q: '②強制換気の送気法',
  s: 'M03', ch: '人工呼吸器の設定',
  type: 'indent',
  rows: [
    { level: 0, text: '・【VC】(【従量】式)：一定の1回換気量が保証される．気道内圧の過度な上昇のおそれがある' },
    { level: 0, text: '・【PC】(【従圧】式)：気道内圧を一定に保つ．1回換気量が減少するおそれがある' },
  ]
},
{
  q: '③【PSV】(【プレッシャーサポート】換気)は患者の自発呼吸(吸気時)に合わせてあらかじめ設定した圧を補助するものである．',
  s: 'M03', ch: '人工呼吸器の設定',
},
{
  q: '④人工呼吸器で設定する代表的な数値',
  s: 'M03', ch: '人工呼吸器の設定',
  type: 'indent',
  rows: [
    { level: 0, text: '・1回換気量：体重(kg)×【8】～【10】mL' },
    { level: 0, text: '・呼吸回数：8～16回' },
    { level: 0, text: '・FIO2：40～100%' },
    { level: 0, text: '・吸気圧：10cmH2O' },
    { level: 0, text: '・PEEP：5cmH2O' },
    { level: 0, text: '・PS：5cmH2O' },
    { level: 0, text: '・最大気道内圧：30cmH2O以下' },
    { level: 0, text: '・吸気時間：1秒' },
    { level: 0, text: '・I：E比：1：2' },
  ]
},
{
  q: '⑤【PEEP】(呼気終末陽圧)は呼気終末にかかっている陽圧のことで，【肺胞】の【虚脱】を防ぎ，酸素化を改善できる．使用により胸腔内圧が上昇するため血圧【低下】，尿量【低下】，頭蓋内圧【亢進】がみられる．合併症として肺の損傷や【気胸】に注意．',
  s: 'M03', ch: '人工呼吸器の設定',
},
{
  q: '⑥ARDSについて',
  s: 'M03', ch: '人工呼吸器の設定',
  type: 'indent',
  rows: [
    { level: 0, text: '・何らかの侵襲により1週間以内に急性発症する，両側びまん性浸潤影を伴う非心原性肺水腫・低酸素血症(P/F＜300)を【ARDS】という．' },
    { level: 0, text: '・肺の血管透過性【亢進】，びまん性肺胞障害，【線維】化を認める．' },
    { level: 0, text: '・FIO2を上げすぎない．' },
    { level: 0, text: '・低換気量(6-8mL/kg)とし，換気回数を増やす．' },
    { level: 0, text: '・PEEPをかける．' },
    { level: 0, text: '・最大気道内圧＜30cmH2O' },
  ]
},

]